import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-generated-reports-dialog.controller';
import template from './edit-generated-reports-dialog.html';

class dialogService {
  getOptions($event, { hasAdvisoryServices, reportPackage, usesUpdatedReportPackaging }) {
    return {
      controller,
      controllerAs: 'editGeneratedReportsDialogVM',
      locals: {
        hasAdvisoryServices,
        reportPackage,
        usesUpdatedReportPackaging,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular
  .module('app.components.reports.packageReports.editGeneratedReportsDialog', [
    alerts,
    amDataService,
    constants,
    docDataService,
    loaderService,
    orgDataService,
    ssDialogService,
    userService,
  ])
  .service('editGeneratedReportsDialog', dialogService).name;
